import React from 'react';
import { InternalMainEntry } from '../../../../../../types/InternalMainEntryType';
import { ExternalMainEntry } from '../../../../../../types/ExternalMainEntryType';
import { ExternalMainEntryCard } from './ExternalMainEntryCard';
import { InternalMainEntryCard } from './InternalMainEntryCard';
import * as S from './Styles';

interface MainEntriesBlockProps {
  node: MainEntriesProps;
}

export interface MainEntriesProps {
  key: string;
  mainEntriesList: (InternalMainEntry | ExternalMainEntry)[];
  type: 'mainEntries';
}

export const MainEntries = ({ node: { mainEntriesList } }: MainEntriesBlockProps) => (
  <S.Wrapper>
    {mainEntriesList &&
      mainEntriesList?.map((e) => {
        switch (e.type) {
          case 'externalLink':
            return <ExternalMainEntryCard externalMainEntry={e} key={e.key} />;
          case 'internalLink':
            return <InternalMainEntryCard internalMainEntry={e} key={e.key} />;
          default:
            return null;
        }
      })}
  </S.Wrapper>
);
